import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonLibraryStepTemplateOverview, CommonLibraryStepTemplateTopics } from "../../CommonComponents/CommonLibraryStepTemplateViews";

export const LibraryStepTemplatesBuiltInRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.stepTemplates.builtIn,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryStepTemplateOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryStepTemplateTopics />;
    },
};
